module.exports = __webpack_public_path__ + "static/media/Logo.e93f50fc.svg";